<template>
  <div class="news">
    <p class="newTitle">关于广源</p>
    <div class="newsType">
      <div class="lTitle">
        <span>ABOUT</span>
      </div>
    </div>
    <div class="about" v-html="about.company"></div>
    <div class="more hidden-sm-and-up">
      <button @click="$router.push({path:'/about'})">更多</button>
    </div>
  </div>
</template>

<script>
import request from "../../assets/js/request.js";
import qs from "qs";
export default {
  data() {
    return {
      about: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      request
        .post(this.settings.apiBaseUrl + "/api/index/about", qs.stringify({}), {
          headers: {},
        })
        .then((res) => {
          if (res.code == 1) {
            this.about = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
};
</script>

<style scoped="scoped">
.news {
  width: 100%;
  height: 540px;
  background-image: url(../../assets/images/home/about.png);
  background-size: 100% 100%;
  padding: 50px 220px;
}

.news .newTitle {
  height: 30px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 18px;
}

.newsType .lTitle {
  margin-top: 20px;
  width: 100%;
  height: 40px;
  display: inline-block;
  line-height: 40px;
}

.lTitle span {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 18px;
  opacity: 0.5;
}

.about {
  margin-top: 60px;
  width: 60%;
}

.about {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3f3f3f;
  line-height: 35px;
}
@media screen and (max-width: 750px) {
  .news .newTitle {
    height: 30px;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    line-height: 0.1rem;
    cursor: pointer;
    font-weight: bold;
    text-align: center;
    color: #216bd1;
  }

  .newsType .lTitle {
    width: 100%;
    height: 40px;
    display: inline-block;
    line-height: 40px;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
  }
  .lTitle span {
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    line-height: 18px;
    opacity: 0.5;
  }
  .about {
    margin: 40px auto;
    width: 90%;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3f3f3f;
    line-height: 0.3rem;
  }
  .news {
    width: 100%;
    height: auto;
    padding: 70px 20px;
    background-color: #ffffff;
    background-image: url();
  }
  .more {
    width: 100%;
    height: auto;
    text-align: center;
    margin-top: 40px;
  }

  .more button {
    width: 2rem;
    height: 0.45rem;
    background: #ffffff;
    border: 1px solid #216bd1;
    border-radius: 5px;
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #216bd1;
    line-height: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/about.vue